import { getMemberKey, getNodeLabel } from 'Services/WeaverUtils'
import cuid from 'cuid'

graphClause = (type) ->
  return '' unless type.graph
  " #{ type.graph } #{ type.id() } _ _ . "

getKeys = (type, keyType = 'isURI') ->
  bindings = await new Weaver.Sparql("""
    SELECT DISTINCT ?key WHERE {
      ?s <type> <#{ type.id() }> .
      #{ graphClause(type) }
      ?s ?key ?o .
      FILTER(#{ keyType }(?o))
    }
  """).find()
  keys = bindings.key.map(({ nodeId }) -> nodeId )
  _.uniq(keys)

getSignature = (type) ->
  attrKeys = await getKeys(type, 'isLiteral')
  relKeys = await getKeys(type).filter((key) -> key isnt getMemberKey())
  { type, attrKeys, relKeys }

defaultAttrField = (key) -> defaultField('string')(key)
defaultRelField = (key) ->  defaultField('select', { derivedData: { querySource: 'all' }})(key)

defaultField = (type, rest) -> (key) ->
  {
    formItem: key,
    formItemType: type,
    formItemLabel: _.startCase(key),
    rest...
  }


class InitiateTypeService

  getInitiateTypeConfig: (typeId, typeGraph) ->
    typeGraph = undefined if typeGraph is 'null'
    typeNode = await Weaver.Node.loadFromGraph(typeId, typeGraph)
    signature = await getSignature(typeNode)
    @buildForm(signature, typeNode)

  buildForm: (signature, typeNode) ->
    {
      key: cuid()
      title: "New #{ getNodeLabel(typeNode) }"
      component: 'sequenced_form'
      formSequence: {
        onSave:
          node: { typeNode: typeNode.id(), typeLabel: getNodeLabel(typeNode), typeGraph: typeNode.graph }
          confirmation: "#{ getNodeLabel(typeNode) } instantiated successfully."
        queries: [{ id: 'all', data: { query: '' } }]
        @getStepsAndFieldData(signature)...
      }
    }

  getStepsAndFieldData: ({ attrKeys, relKeys }) ->
    fieldList = attrKeys.map(defaultAttrField)
      .concat(relKeys.map(defaultRelField))
    {
      sequence: [{ fields: attrKeys.concat(relKeys) }]
      formFields: fieldList
    }

export default new InitiateTypeService()
